'use client';

import { VStack } from '@terra/ui-styled-system';
import { useTranslations } from 'next-intl';
import { Dialog } from '../../../components/dialog';
import { UnverifiedAssetLockedEndpointField } from './UnverifiedAssetLockedEndpointField';

type UnverifiedAssetProbeSuccessDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onViewVerifiedAsset: () => void;
  method: string;
  endpoint: string;
  canViewVerifiedAsset?: boolean;
};

export function UnverifiedAssetProbeSuccessDialog({
  open,
  onOpenChange,
  onViewVerifiedAsset,
  method,
  endpoint,
  canViewVerifiedAsset = true,
}: UnverifiedAssetProbeSuccessDialogProps) {
  const t = useTranslations('designSystem.applicationAssets');
  const tCommon = useTranslations('designSystem.common');

  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
      size="sm"
      title={t('rerunSuccessTitle')}
      description={t('rerunSuccessDescription')}
      closeLabel={tCommon('close')}
      lazyMount
      unmountOnExit
      primaryAction={{
        label: t('rerunSuccessViewAsset'),
        disabled: !canViewVerifiedAsset,
        onClick: onViewVerifiedAsset,
      }}
    >
      <VStack gap="3" alignItems="stretch" w="full">
        <UnverifiedAssetLockedEndpointField
          method={method}
          endpoint={endpoint}
          label={t('rerunSuccessNewAssetLabel')}
        />
      </VStack>
    </Dialog>
  );
}
